import $ from 'jquery';
import lodash from './lsag.lodash';

const stickyHeader = {
    isSticky: false,
    attachedScrollHandler: false,
    header: $('#header-sticky-placeholder'),
    $scrollTop: $('#js-scroll-top'),
    getHeaderHeight: function () {
        return this.header.outerHeight(true);
    },
    stick: function () {
        $('body').css({'margin-top': this.getHeaderHeight() + 'px'});
        $('.page-header').addClass('page-header--sticky');
        $('.l-nav-wrapper__border').removeClass('flex-wrap');
        $('.js-country-selector[aria-expanded="true"]').dropdown('toggle');
        // https://css-tricks.com/updating-a-css-variable-with-javascript/
        document.documentElement.style.setProperty('--header-height', $('#header-sticky-placeholder').innerHeight() + 'px');
        this.$scrollTop.removeAttr('aria-hidden');
        this.$scrollTop.parent().addClass('scroll-top--visible');
        this.isSticky = true;
    },
    unstick: function () {
        $('.page-header').removeClass('page-header--sticky');
        $('body').css({'margin-top': ''});
        $('.l-nav-wrapper__border').addClass('flex-wrap');
        document.documentElement.style.setProperty('--header-height', $('#header-sticky-placeholder').innerHeight() - ($('.l-top-bar').outerHeight() ?? 0) + 'px');
        this.$scrollTop.attr('aria-hidden', 'true');
        this.$scrollTop.parent().removeClass('scroll-top--visible');
        this.isSticky = false;
    },
    stickSave: function () {
        if ($(window).scrollTop() > this.getHeaderHeight()) {
            this.stick();
        }
        if (!this.attachedScrollHandler) {
            this.bindStick();
        }
    },
    unstickSave: function () {
        if (this.attachedScrollHandler) {
            this.unbindStick();
        }
        if (this.isSticky) {
            this.unstick();
        }
    },
    relocateHeader: function () {
        if ($(window).scrollTop() > this.getHeaderHeight()) {
            if (this.isSticky) return;
            this.stick();
        } else {
            if (!this.isSticky) return;
            this.unstick();
        }
    },
    bindStick: function () {
        this.relocateHeader();
        $(window).on('scroll.sticky', lodash.throttle(() => {
            if (this.attachedScrollHandler) {
                this.relocateHeader();
            }
        }, 250));
        this.attachedScrollHandler = true;
    },
    unbindStick: function () {
        this.attachedScrollHandler = false;
        $(window).off('scroll.sticky');
    }
};

$(function () {
    stickyHeader.bindStick();
    stickyHeader.unstick();
});

export default stickyHeader;
